export enum cuveTypes {
    LOADING = "LOADING",
    SELECTED_CUVE = "SELECTED_CUVE",
    GET_CUVE_LIST = "GET_CUVE_LIST",
    GET_CUVE_DETAIL = "GET_CUVE_DETAIL",
}
  
export default cuveTypes;